import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Mail, UserPlus, Copy, X } from 'lucide-react';
import { RoleBadge } from './shared';

export const AdminInvitesPanel = ({ invites, onOpenCreate, onCopyLink, onRevoke }) => (
  <Card className="bg-zinc-950/60 border-white/5">
    <CardHeader className="flex flex-row items-center justify-between gap-4 flex-wrap">
      <CardTitle className="font-heading text-lg flex items-center gap-2">
        <Mail className="w-4 h-4 text-muted-foreground" />
        Pending Invites
        <span className="text-sm text-muted-foreground font-normal">({invites.length})</span>
      </CardTitle>
      <Button onClick={onOpenCreate} data-testid="admin-invite-button">
        <UserPlus className="w-4 h-4 mr-2" />
        Invite teammate
      </Button>
    </CardHeader>
    <CardContent>
      {invites.length === 0 ? (
        <p className="text-sm text-muted-foreground py-4">
          No pending invites. Click <span className="text-foreground">Invite teammate</span> to onboard a co-operator.
        </p>
      ) : (
        <div className="space-y-2" data-testid="admin-invites-list">
          {invites.map(inv => (
            <div
              key={inv.id}
              className="flex items-center gap-3 p-3 rounded-lg bg-zinc-900/40 border border-white/5"
              data-testid={`admin-invite-row-${inv.email}`}
            >
              <Mail className="w-4 h-4 text-muted-foreground" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="text-sm font-medium truncate">{inv.email}</p>
                  <RoleBadge role={inv.role} />
                </div>
                <p className="text-xs text-muted-foreground mt-0.5">
                  Invited by {inv.invited_by_name} · expires {new Date(inv.expires_at).toLocaleDateString()}
                </p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onCopyLink(inv.accept_url)}
                data-testid={`admin-invite-copy-${inv.email}`}
              >
                <Copy className="w-3.5 h-3.5 mr-1.5" />
                Copy link
              </Button>
              <Button
                variant="ghost"
                size="sm"
                className="text-destructive hover:text-destructive hover:bg-destructive/10"
                onClick={() => onRevoke(inv.id)}
                data-testid={`admin-invite-revoke-${inv.email}`}
              >
                <X className="w-3.5 h-3.5" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
